import { IOrderBumpCheckout } from "@CheckoutStepsOffers/@types/offer";

export const handleSelectOrderBump = (
  orderBump: IOrderBumpCheckout,
  setOrderBumpsSelected: React.Dispatch<
    React.SetStateAction<IOrderBumpCheckout[]>
  >,
) => {
  const isSelectedOrderBump = (
    orderBump: IOrderBumpCheckout,
    orderBumps: IOrderBumpCheckout[],
  ) => orderBumps?.some((item) => item?.id === orderBump?.id);

  const removeOrderBump = (
    orderBump: IOrderBumpCheckout,
    orderBumps: IOrderBumpCheckout[],
  ) => orderBumps?.filter((item) => item?.id !== orderBump?.id);

  const getOrderBumpList = (
    orderBump: IOrderBumpCheckout,
    orderBumps: IOrderBumpCheckout[],
  ) => {
    const isSelected = isSelectedOrderBump(orderBump, orderBumps);

    if (isSelected) {
      return removeOrderBump(orderBump, orderBumps);
    }

    return [orderBump, ...orderBumps];
  };

  return setOrderBumpsSelected((prevState) =>
    getOrderBumpList(orderBump, prevState),
  );
};
